import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import LazyLoadImage from 'components/LazyLoadImage'
import {
  trackProductImpression,
  createTrackingStructure,
  trackProductClick
} from 'utils/tagManager'
import ProductBlockButtons from './ProductBlockButtons'
import ProductBlockPrice from './ProductBlockPrice'
import { Sticker, StickerLeft } from './ProductBlockSticker'
import TasteProfileMatchBadge from '../TasteProfileMatchBadge'

import styles from './productBlock.css'

class ProductBlock extends PureComponent {
  render () {
    const {
      absoluteUrl,
      category,
      imageUrls,
      price,
      sku,
      title,
      sticker,
      tasteProfileMatch
    } = this.props

    return (
      <div
        className={styles.productBlock}
        data-sku={sku}
        {...trackProductImpression(title, sku, price, category)}
        data-tracking-structure={createTrackingStructure()}
      >
        <a
          href={absoluteUrl}
          className={styles.productLink}
          {...trackProductClick(title, sku, price, category)}
        >
          <div className={styles.left}>
            <LazyLoadImage className={styles.image} src={imageUrls.medium} alt={title} />
            <StickerLeft {...sticker} />
          </div>

          <div className={styles.right}>
            <TasteProfileMatchBadge match={tasteProfileMatch} />
            <ProductBlockPrice price={price} />
            <Sticker
              title={price.discountedLoyalty}
              text={price.discountedLoyalty && 'KAART HOUDERS'}
            />
          </div>

          <div className={styles.title}>
            {title}
          </div>
        </a>

        <ProductBlockButtons {...this.props} />
      </div>
    )
  }
}

ProductBlock.propTypes = {
  absoluteUrl: PropTypes.string.isRequired,
  category: PropTypes.array.isRequired,
  imageUrls: PropTypes.shape({
    medium: PropTypes.string
  }),
  price: PropTypes.shape({
    retail: PropTypes.string,
    discounted: PropTypes.string,
    discountedLoyalty: PropTypes.string
  }).isRequired,
  sku: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  sticker: PropTypes.object,
  tasteProfileMatch: PropTypes.number
}

ProductBlock.defaultProps = {
  imageUrls: {
    medium: ''
  },
  price: {
    retail: '',
    discounted: '',
    discountedLoyalty: ''
  },
  sticker: {},
  tasteProfileMatch: null
}

export default ProductBlock
